const _excluded = ["name", "title", "icon"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { lazy } from 'react';
import { definePlugin } from 'sanity';
import { route } from 'sanity/router';
import { EyeOpenIcon } from '@sanity/icons';
const visionTool = definePlugin(options => {
  const _ref = options || {},
    {
      name,
      title,
      icon
    } = _ref,
    config = _objectWithoutProperties(_ref, _excluded);
  return {
    name: "@sanity/vision",
    tools: [{
      name: name || "vision",
      title: title || "Vision",
      icon: icon || EyeOpenIcon,
      component: lazy(() => import('./_chunks/SanityVision-d9d98eef.esm.js')),
      options: config,
      router: route.create("/*")
    }]
  };
});
export { visionTool };
//# sourceMappingURL=index.esm.js.map
